import axiosInstance from "./axiosInstance";

// Ecumatic support tickets (VDP backend /ecu/tickets -> Ecumatic partner API). A customer sees
// their own; an admin sees every customer's (each row carries `vdpUsername`).

// The request subjects VDP customers can open (Ecumatic also has Tuning / Special requests,
// which VDP doesn't offer).
export const SUBJECT_TYPES = [
  { value: "NEW_SOLUTION", label: "New Solution Request", needsItems: true },
  { value: "BUG", label: "Report A Bug", needsDescription: true, needsModified: true },
];

export const listEcuTickets = async () => {
  const response = await axiosInstance.get("/ecu/tickets");
  return Array.isArray(response.data) ? response.data : [];
};

export const getEcuTicketOptions = async (brand, ecu) => {
  const response = await axiosInstance.get("/ecu/tickets/options", { params: { brand, ecu } });
  return response.data || { modules: [], tunings: [] };
};

export const createEcuTicket = async ({
  subjectType,
  brand,
  ecu,
  description,
  items = [],
  original,
  modified,
}) => {
  const formData = new FormData();
  formData.append("subjectType", subjectType);
  formData.append("brand", brand);
  formData.append("ecu", ecu);
  if (description && description.trim()) formData.append("description", description.trim());
  items.forEach((item) => formData.append("item", item));
  if (original) formData.append("original", original);
  if (modified) formData.append("modified", modified);
  const response = await axiosInstance.post("/ecu/tickets", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getEcuTicket = async (id) => {
  const response = await axiosInstance.get(`/ecu/tickets/${id}`);
  return response.data;
};

export const replyEcuTicket = async (id, message) => {
  const response = await axiosInstance.post(`/ecu/tickets/${id}/messages`, { message });
  return response.data;
};

export const closeEcuTicket = async (id) => {
  const response = await axiosInstance.put(`/ecu/tickets/${id}/close`);
  return response.data;
};

export const downloadEcuTicketAttachment = async (id, attachmentId, fallbackName) => {
  const response = await axiosInstance.get(`/ecu/tickets/${id}/attachments/${attachmentId}`, {
    responseType: "blob",
  });
  let fileName = fallbackName || "attachment.bin";
  const disposition = response.headers["content-disposition"];
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match.length > 1) fileName = match[1];
  }
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Admin: point Ecumatic's ticket-reply webhook at this VDP server, so customers are notified
// when Ecumatic support replies. Returns what Ecumatic saved ({url, secret}).
export const connectEcuWebhook = async () => {
  const response = await axiosInstance.post("/ecu/webhook/register", {});
  return response.data;
};

// Admin: ask Ecumatic to send a test ping to the webhook now ({delivered, status, error}).
export const testEcuWebhook = async () => {
  const response = await axiosInstance.post("/ecu/webhook/test");
  return response.data;
};

// The backend's / Ecumatic's {"error": "..."} body, or a fallback.
export const ticketErrorMessage = async (err, fallback) => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed?.error || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.error || data?.message || fallback;
};
